import { OFFICE_CARD_FRAGMENT } from './fragments'

const { gql } = require('graphql-request')

export const GET_OFFICE_CARD = gql`
  query GetOfficeCard($id: ID!) {
    getOfficeCard(id: $id) {
      ...officeCardInfo
    }
  }
  ${OFFICE_CARD_FRAGMENT}
`

export const GET_CARD_BY_OFFICE = gql`
  query GetCardByOffice($officeId: ID!) {
    getCardByOffice(officeId: $officeId) {
      ...officeCardInfo
    }
  }
  ${OFFICE_CARD_FRAGMENT}
`

const queries = {
  GET_OFFICE_CARD,
  GET_CARD_BY_OFFICE
}

export default queries 